/*
 *
 *  * (C) Copyright 2006-2020 hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * All Rights Reserved.
 *  *
 *  * These materials are unpublished, proprietary, confidential source code of
 *  * hSenid Mobile Solutions (Pvt) Limited and constitute a TRADE SECRET
 *  * of hSenid Mobile Solutions (Pvt) Limited.
 *  *
 *  * hSenid Mobile Solutions (Pvt) Limited retains all title to and intellectual
 *  * property rights in these materials.
 *  *
 *
 */

import React, { useState } from "react";
import moment from "moment";
import { AppReview } from "../../../api/apiCalls";
import { ImgStatic } from "../../Common/element/ImgStatic";

export default function ReviewCard({ name, comment, reviewDate }: AppReview) {
  const [isTruncate, setIsTruncate] = useState<boolean>(true);
  return (
    <div className="col-sm-6">
      <div className="card mt-3 border-0">
        <div className="row no-gutters">
          <div className="col-1">
            <ImgStatic name={"default-profile-icon.png"} className="card-img" />
          </div>
          <div className="col-11">
            <div className="card-body pl-3 p-0">
              <div className="row no-gutters">
                <div className="col-sm-8">
                  <p className="font-weight-bold mb-0">{name}</p>
                </div>
                <div className="col-sm-4 text-sm-right">
                  <p className="card-text mb-1">
                    <small className="text-muted">
                      {moment(reviewDate).format("MMM D YYYY")}
                    </small>
                  </p>
                </div>
              </div>
              {comment.length > 66 ? (
                <div>
                  {isTruncate ? (
                    <div>
                      <p className="sub-text text-truncate">{comment}</p>
                      <span
                        style={{ cursor: "pointer" }}
                        className="card-link text-secondary"
                        onClick={() => setIsTruncate(false)}
                      >
                        Read More
                      </span>
                    </div>
                  ) : (
                    <div>
                      <p className="sub-text">{comment}</p>
                      <span
                        style={{ cursor: "pointer" }}
                        className="card-link text-secondary"
                        onClick={() => setIsTruncate(true)}
                      >
                        Less
                      </span>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  <p className="sub-text">{comment}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
